"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrintInRed = exports.GroupBy = exports.SortBy = exports.NotifierDisplayStyle = exports.GroupDisplayStyle = exports.PrinterProfileType = void 0;
var PrinterProfileType;
(function (PrinterProfileType) {
    PrinterProfileType["BILLING"] = "BILLING";
    PrinterProfileType["KITCHEN"] = "KITCHEN";
})(PrinterProfileType = exports.PrinterProfileType || (exports.PrinterProfileType = {}));
var GroupDisplayStyle;
(function (GroupDisplayStyle) {
    GroupDisplayStyle["HEADING"] = "HEADING";
    GroupDisplayStyle["SEPARATOR"] = "SEPARATOR";
    GroupDisplayStyle["HIDDEN"] = "HIDDEN";
})(GroupDisplayStyle = exports.GroupDisplayStyle || (exports.GroupDisplayStyle = {}));
var NotifierDisplayStyle;
(function (NotifierDisplayStyle) {
    NotifierDisplayStyle["SHOW_FULL_CONTENT"] = "SHOW_FULL_CONTENT";
    NotifierDisplayStyle["SHOW_SUMMARY"] = "SHOW_SUMMARY";
})(NotifierDisplayStyle = exports.NotifierDisplayStyle || (exports.NotifierDisplayStyle = {}));
var SortBy;
(function (SortBy) {
    SortBy["EXACT_CART_ORDER"] = "EXACT_CART_ORDER";
    SortBy["CATEGORY"] = "CATEGORY";
    SortBy["SEAT"] = "SEAT";
    SortBy["SEQUENCE_NUMBER"] = "SEQUENCE_NUMBER";
})(SortBy = exports.SortBy || (exports.SortBy = {}));
var GroupBy;
(function (GroupBy) {
    GroupBy["COURSE"] = "COURSE";
    GroupBy["SEAT"] = "SEAT";
    GroupBy["CATEGORY"] = "CATEGORY";
})(GroupBy = exports.GroupBy || (exports.GroupBy = {}));
var PrintInRed;
(function (PrintInRed) {
    PrintInRed["MODIFIERS"] = "MODIFIERS";
    PrintInRed["NOTES"] = "NOTES";
    PrintInRed["ALLERGIES"] = "ALLERGIES";
    PrintInRed["REMOVES"] = "REMOVES";
})(PrintInRed = exports.PrintInRed || (exports.PrintInRed = {}));
//# sourceMappingURL=printerProfiles.js.map